export default "__VITE_ASSET__d00bce52__"